import { BsWhatsapp } from 'react-icons/bs'
import { FloatButton } from './style'

interface FloatButtonWhatsappProps {
  visible?: boolean
}
const FloatButtonWhatsapp = ({ visible }: FloatButtonWhatsappProps) => {
  return (
    <>
      {visible && (
        <FloatButton
          onClick={() => {
            window.open(
              'https://api.whatsapp.com/send/?phone=551620182597&text=Acessei+o+site+e+quero+saber+mais+sobre+as+op%C3%A7%C3%B5es+de+cr%C3%A9dito+dispon%C3%ADvel&type=phone_number&app_absent=0',
              '_blank'
            )
          }}
        >
          <BsWhatsapp size={30} />
        </FloatButton>
      )}
    </>
  )
}

export default FloatButtonWhatsapp
